export class LocalSession {
  public create(authToken: string): boolean {
    localStorage.setItem(
      'authToken',
      JSON.stringify({
        payload: {
          auth_time: new Date().toDateString(),
          auth_token: authToken
        }
      })
    );
    return false;
  }

  public destroy(): boolean {
    localStorage.removeItem('authToken');

    return true;
  }

  public currentAuthenticatedUser() {}

  public getAccessToken(): IAccessToken {
    const auth_time = new Date().toDateString();

    return {
      getJwtToken: async () => {
        try {
          return (
            (JSON.parse(localStorage.getItem('authToken') as string) as IAccessToken).payload
              .auth_token ?? ''
          );
        } catch (error) {
          console.error(error);
          return '';
        }
      },
      payload: {
        auth_time: auth_time,
        auth_token: ''
      }
    };
  }

  public isUserSignedIn() {
    return false;
  }
}
